<template>
  <ul class="card-brand-logos" aria-label="Visa, Mastercard">
    <li><img src="@/assets/img/payments/visa-blue.png" alt="Visa" width="80" height="40" /></li>
    <li><img src="@/assets/img/payments/mastercard-symbol.png" alt="Mastercard" width="80" height="40" /></li>
  </ul>
</template>

<script>
export default { name: 'CardBrandLogos' }
</script>

<style scoped>
.card-brand-logos { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; padding: 0; margin: 16px 0 0; list-style: none; }
.card-brand-logos li { display: flex; align-items: center; justify-content: center; box-sizing: border-box; width: 112px; height: 64px; padding: 12px; background: #fff; border: 1px solid #e5e5e5; border-radius: 6px; }
.card-brand-logos img { display: block; width: 80px; height: 40px; object-fit: contain; }
</style>
